var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-pop", {
    staticClass: "modal",
    attrs: {
      opened: _vm.popupOpen,
      modalHeader: true,
      modalFooter: true,
      title:
        _vm.siteCode == _vm.$config.SITECODE_OGMMR
          ? ""
          : _vm.$t("MMAIN-06-01-01-01")
    },
    on: {
      "update:opened": function($event) {
        _vm.popupOpen = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _vm.siteCode == _vm.$config.SITECODE_OGMMR
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        /*- This version of the application is no longer supported.*/ _vm.$t(
                          "MMAIN-06-01-01-05"
                        )
                      )
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          /*- Please update to the latest version from the Play Store or Apple Store to continue using the application with the newest features.*/ _vm.$t(
                            "MMAIN-06-01-01-06"
                          )
                        ) +
                        " "
                    )
                  ])
                ])
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        /*Please update to the latest version for stable use.*/ _vm.$t(
                          "MMAIN-06-01-01-02"
                        )
                      )
                    )
                  ])
                ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn bottom positive",
                on: {
                  click: function($event) {
                    return _vm.goToMarket()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.siteCode == _vm.$config.SITECODE_OGMMR
                        ? _vm.$t("MOTP-01-01-04-04")
                        : _vm.$t("MMAIN-06-01-01-03")
                    ) +
                    " "
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }